module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"label":{"inputResult":"Input result"}},"ja":{"label":{"inputResult":"結果を入力"}}}')
  delete Component.options._Ctor
}
